// Dates in the format below must include a time string or else they will
// reference the date one day before the actual date
const TRICKY_YEAR_MONTH_DATE_FORMAT = 'yyyy-MM-dd'

const EMPTY_TIME_STRING = 'T00:00:00'

type verifyValidDateStringType = (
  value: Date | string | number | null,
) => Date | number | string | null

const verifyValidDateString: verifyValidDateStringType = (value) => {
  if (typeof value !== 'string') return value
  if (
    value.length !== TRICKY_YEAR_MONTH_DATE_FORMAT.length ||
    value.charAt(4) !== '-' ||
    value.charAt(7) !== '-'
  )
    return value

  return value + EMPTY_TIME_STRING
}

export default verifyValidDateString
